import axios from "axios";
import { AxiosError } from "axios";
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
import { Action } from "api/action_types/quote";
import { Action as AuthAction } from "api/action_types/authentication";
import { ActionType } from "api/action_types/quote";
import { ActionType as AuthActionType } from "api/action_types/authentication";
import { Quote } from "api/types/quote";
import { url_prefix } from "settings";
import { quote_url } from "../endpoint";

export const updateQuote = (
  quote: Quote,
  id: number | string,
  quote_requested: boolean | null | undefined,
  no_update_local?: boolean
) => {
  return async (dispatch: Dispatch<Action | AuthAction>, getState: () => RootState) => {
    const { user } = getState().authentication;

    dispatch({
      type: ActionType.QUOTE_UPDATING
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${user.token}`
      }
    }

    let url = `${url_prefix}${quote_url}/${id}/?`;

    if (quote_requested) {
      url += "quote_requested=true&";
    }

    try {
      const { data } = await axios.patch(url, quote, config);

      if (!no_update_local) {
        dispatch({
          type: ActionType.UPDATE_QUOTE_SUCCESS,
          payload: data.quote
        });

      if (quote_requested) {
          dispatch({
            type: ActionType.GET_AREAS_SUCCESS,
            payload: data.areas
          });
        }

      }
      else {
        dispatch({
          type: ActionType.QUOTE_ACTION_SUCCESS
        });
      }
    }
    catch (err) {
      if (err instanceof AxiosError) {
        dispatch({
          type: ActionType.QUOTE_ERROR,
          payload: err.message
        });
        if (err && err.response && err.response.status === 401) {
          dispatch({
            type: AuthActionType.AUTH_FAILED
          });
        }
      }
    }
  }
}
